import { Globe, MapPin } from 'lucide-react';

const locations = [
  { name: 'Los Angeles', region: 'North America', position: { top: '38%', left: '15%' } },
  { name: 'Sydney', region: 'Australia', position: { top: '75%', left: '85%' } },
  { name: 'Singapore', region: 'Asia Pacific', position: { top: '55%', left: '72%' } },
  { name: 'Rotterdam', region: 'Europe', position: { top: '30%', left: '48%' } },
  { name: 'Dubai', region: 'Middle East', position: { top: '42%', left: '58%' } },
  { name: 'Shanghai', region: 'Asia', position: { top: '40%', left: '78%' } },
];

export const GlobalNetwork = () => {
  return (
    <section className="py-20 lg:py-32 bg-navy relative overflow-hidden" data-testid="global-network">
      <div className="rsl-container relative z-10">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-safety-orange font-mono text-xs tracking-widest uppercase">
            Worldwide Coverage
          </span>
          <h2 className="text-4xl lg:text-5xl font-black text-white uppercase tracking-tight mt-2 mb-4">
            Global Network
          </h2>
          <p className="text-white/70 text-lg">
            Connecting five continents with strategically located offices and partners in major international ports.
          </p>
        </div>

        {/* Map Container */}
        <div className="relative aspect-[2/1] max-w-5xl mx-auto">
          {/* World Map SVG Background */}
          <div className="absolute inset-0 opacity-20">
            <svg viewBox="0 0 1000 500" className="w-full h-full">
              <path
                fill="currentColor"
                className="text-white"
                d="M150,100 Q200,80 250,100 T350,100 Q400,80 450,100 T550,100 L550,150 Q500,170 450,150 T350,150 Q300,170 250,150 T150,150 Z
                   M600,100 Q650,80 700,100 T800,100 L800,180 Q750,200 700,180 T600,180 Z
                   M100,200 Q150,180 200,200 T300,200 Q350,220 400,200 L400,280 Q350,300 300,280 T200,280 Q150,300 100,280 Z
                   M450,200 Q500,180 550,200 T650,200 L650,320 Q600,340 550,320 T450,320 Z
                   M700,220 Q750,200 800,220 T900,220 L900,350 Q850,370 800,350 T700,350 Z
                   M200,350 Q250,330 300,350 T400,350 L400,420 Q350,440 300,420 T200,420 Z
                   M750,380 Q800,360 850,380 L850,450 Q800,470 750,450 Z"
              />
            </svg>
          </div>

          {/* Location Points */}
          {locations.map((location, index) => (
            <div
              key={location.name}
              className="absolute group cursor-pointer"
              style={{ top: location.position.top, left: location.position.left }}
              data-testid={`map-point-${index}`}
            >
              {/* Pulse Animation */}
              <div className="absolute -inset-3 bg-safety-orange/30 rounded-full animate-ping" />
              
              {/* Point */}
              <div className="relative w-4 h-4 bg-safety-orange rounded-full shadow-lg shadow-safety-orange/50" />
              
              {/* Tooltip */}
              <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                <div className="bg-white px-4 py-2 shadow-lg whitespace-nowrap">
                  <p className="font-bold text-navy text-sm">{location.name}</p>
                  <p className="text-slate-500 text-xs">{location.region}</p>
                </div>
                <div className="absolute top-full left-1/2 -translate-x-1/2 border-8 border-transparent border-t-white" />
              </div>
            </div>
          ))}

          {/* Connection Lines */}
          <svg className="absolute inset-0 w-full h-full pointer-events-none opacity-30">
            <defs>
              <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#FF5722" stopOpacity="0" />
                <stop offset="50%" stopColor="#FF5722" stopOpacity="1" />
                <stop offset="100%" stopColor="#FF5722" stopOpacity="0" />
              </linearGradient>
            </defs>
            <path
              d="M150,190 Q400,100 480,200 Q600,150 720,110"
              stroke="url(#lineGradient)"
              strokeWidth="2"
              fill="none"
              className="animate-pulse"
            />
            <path
              d="M720,110 Q780,180 850,375"
              stroke="url(#lineGradient)"
              strokeWidth="2"
              fill="none"
              className="animate-pulse"
              style={{ animationDelay: '0.5s' }}
            />
          </svg>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 pt-16 border-t border-white/10">
          <div className="text-center">
            <p className="text-4xl font-black text-safety-orange">120+</p>
            <p className="text-white/70 text-sm mt-2">Countries Served</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-black text-safety-orange">50+</p>
            <p className="text-white/70 text-sm mt-2">Port Partners</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-black text-safety-orange">24/7</p>
            <p className="text-white/70 text-sm mt-2">Global Support</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-black text-safety-orange">6</p>
            <p className="text-white/70 text-sm mt-2">Regional Offices</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalNetwork;
